export default "__VITE_ASSET__BxBRP$8m__"